<template>
  <div class='row-libray'>
    <LeftListSupplier :pos="5"></LeftListSupplier>
    <div class="g-row2">
      <div class="m-hone1 m-libray">
        <div class="top">
          <div class="tit">按ISBN编码查询：</div>
          <a-input-search class="m-so" placeholder="请输入ISBN编码" v-model="search.isbn" @search="onSearch" />
        </div>

        <div class="contect g-contecte1">
          <div class="top1">
            <div class="tit2">图书目录</div>
            <div class="con2">
              <span v-if="!importStatus.finished" style="float: left;">导入中，<em style="color:green;font-size: 16px;">{{importStatus.success}}</em>成功，<em style="color:red;font-size: 16px;">{{importStatus.fail}}</em>失败</span>
              <div class="btn1" @click="showModal">导入目录</div>
              <div class="btn1 btn2" @click="batchDel">批量删除</div>
              <div class="btn1 btn2" @click="clearLibrary">一键清空</div>
            </div>
          </div>

          <div class="m-table" v-loading="!importStatus.finished">

            <a-table :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" rowKey="id" :columns="columns"
              :data-source="data" :pagination="false" :bordered="false"    :scroll="{ x: 700 }">
              <div slot="delete" slot-scope="index, record, indent, expanded" class="delete" style="color: #188EFC;" @click="del(record.id)">
                <span>删除</span>
              </div>
              <!-- <div slot="customTitle"><span class="td1 on" :class="{ active1: isOrderPublishDateOn }"
                  @click="toggleActive1">出版日期<img src="@/assets/images/e-load2.png" class="icon" alt="" /><img
                    src="@/assets/images/e-load2-on.png" class="icon icon2" alt="" /></span></div> -->


              <!-- <div slot="datepublication" slot-scope="publication, record, indent, expanded" class="publication" >
                <span>出版日期</span> <img src="@/assets/images/e-load3.png" class="img" alt="" />
              </div> -->
              <div slot="fixprice"><span class="td1" :class="{ active2: isOrderPriceOn }" @click="toggleActive2">定价<img
                    src="@/assets/images/e-load1.png" class="icon" alt="" /><img src="@/assets/images/e-load1-on.png"
                    class="icon icon2" alt="" /></span></div>
              <div slot="discount"><span class="td1 td2 " :class="{ active: isOrderDiscountOn }" @click="toggleActive">折扣<img
                    src="@/assets/images/e-icon4.png" class="icon" alt="" /><img src="@/assets/images/e-icon4-on.png"
                    class="icon icon2" alt="" /></span></div>
              <!-- <div slot="discount" slot-scope="index, record, indent, expanded" class="discount"
                style="color: #3871E9;">
                <span>折扣</span>
              </div> -->

            </a-table>
          </div>
          <mPages :page.sync="filter.page" :page-size.sync="filter.pageSize" :total="dataCount" />
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <a-modal :visible="visible" class="m-pope1 m-poplibrary" @cancel="handleCancel" :footer="null"
      :centered="true" :closable="false" :width="895">
      <div class="inner">
        <div class="tit">导入目录</div>
        <div class="info">导入.xlsx文件（Excel表格，每行一条书目），图书目录条件模版<a href="/static/bkHome/template/bookImportTemplate.xlsx" download style="color:blue;text-decoration-line: underline;">点击下载</a></div>
        <file-upload accept=".xlsx" v-model="fileUrl" :show-file-list="true" style="position: relative">
          <a-button>
            <div v-if="!fileUrl" class="pic">
              <img src="@/assets/images/e-load3.png" class="img" alt="" />
            </div>
            <div v-if="!fileUrl" class="btn1">点击选择文件</div>
          </a-button>
        </file-upload>
<!--        <a-upload name="file" :multiple="true" action="https://www.mocky.io/v2/5cc8019d300000980a055e76"-->
<!--          :headers="headers" @change="handleChange">-->
<!--          <a-button>-->
<!--            <div class="pic">-->
<!--              <img src="@/assets/images/e-load3.png" class="img" alt="" />-->
<!--            </div>-->
<!--            <div class="btn1">点击选择文件</div>-->
<!--          </a-button>-->
<!--        </a-upload>-->

        <button class="btn" v-loading="saving" @click="importBooks">确认提交</button>
        <!-- <div class="info1">注：提交后目录列表状态显示为已上传</div> -->
      </div>
    </a-modal>
  </div>
</template>

<script>
import LeftListSupplier from "@/components/LeftListSupplier";
import mPages from '@/components/mpages/mPages.vue'
import FileUpload from "@/views/common/FileUpload.vue";
import {getApiData, getApiRes} from "@/api/apiUtil";
import apiBkBook from "@/api/bkBook";
import apiBkCompany from "@/api/bkCompany";
export default {
  components: {
    FileUpload,
    LeftListSupplier,
    mPages,
  },
  data() {
    return {
      //
      isOrderPublishDateOn: false,
      isOrderPriceOn: false,
      isOrderDiscountOn: false,
      //
      ModalText: "Content of the modal",
      visible: false,
      confirmLoading: false,

      // 表单
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        name: '',
        name2: '',
        name3: '',
        name4: '',
        region: undefined,
        region2: undefined,
      },
      // 表格
      selectedRowKeys: [], // Check here to configure the default column
      columns: [
        {
          title: "ISBN",
          dataIndex: "isbn",
          key: "isbn",
          width: '10.1%',

        },
        {
          title: "书名",
          dataIndex: "name",
          key: "name",
          width: '14.2%',
          ellipsis: true,
        },
        {
          title: "出版社",
          dataIndex: "publisher",
          key: "publisher",
          width: '9.5%',
          ellipsis: true,
        },
        {
          title: "作者",
          dataIndex: "author",
          key: "author",
          ellipsis: true,
          width: '11.4%',
        },

        {
          title: "发行时间",
          dataIndex: "publishDate",
          key: "publishDate",
          ellipsis: true,
          width: '7.4%',
          slots: { title: 'customTitle' },
          scopedSlots: { customRender: '发行时间' },
        },

        // {
        //   title: "印刷日期",
        //   dataIndex: "printDate",
        //   key: "printDate",
        //   ellipsis: true,
        //   width: '6.6%',
        // },
        // {
        //   title: "印张",
        //   dataIndex: "page",
        //   key: "page",
        //   ellipsis: true,
        //   width: '3.4%',
        // },
        {
          // title: "定价",
          dataIndex: "price",
          key: "price",
          ellipsis: true,
          width: '6.1%',
          // sorter: true,
          // scopedSlots: { customRender: 'name' },
          slots: { title: 'fixprice' },
          scopedSlots: { customRender: '定价' },
        },
        {
          // title: "折扣",
          dataIndex: "discount",
          key: "discount",
          ellipsis: true,
          width: '14.4%',
          slots: { title: 'discount' },
          scopedSlots: { customRender: '折扣' },
        },
        // {
        //   title: "分类",
        //   dataIndex: "category",
        //   key: "category",
        //   ellipsis: true,
        //   width: '6.1%',
        // },
        // {
        //   title: "读者",
        //   dataIndex: "reader",
        //   key: "reader",
        //   ellipsis: true,
        //   width: '6.1%',
        // },
        {
          title: "开本",
          dataIndex: "pageSize",
          key: "pageSize",
          ellipsis: true,
          width: '10.1%',
        },
        {
          title: "操作",
          dataIndex: "operate",
          key: "operate",
          ellipsis: true,
          width: '9.5%',
          scopedSlots: { customRender: 'delete' },
        },

      ],
      data: [],
      dataCount: 0,
      saving: false,
      fileUrl: '',
      search: {
        isbn: ''
      },
      filter: {
        page: 1,
        pageSize: 20,
        order: undefined,
        field: 'id,isbn,uid,name,publisher, author,publishDate,printDate,page,price,discount,category,reader,supplier,pageSize',
      },
      company: {id: 0},
      importStatus: {
        success: 0,
        fail: 0,
        finished: true,
      }
    };
  },
  computed: {},
  watch: {
    filter:{
      handler() {
        this.load()
      },
      deep: true
    },
    visible(v){
      if(!v) this.fileUrl = ''
    },
    isOrderDiscountOn(){
      this.getOrder('discount')
    },
    isOrderPriceOn(){
      this.getOrder('price')
    },
    isOrderPublishDateOn(){
      this.getOrder('publishDate')
    }
  },
  mounted() {
    // this.load(1)
    this.getImportStatus(false) // 获取导入状态，会自动加载第1页
    this.loadCompany()

    // 检测认证
    if(this.$store.state.user.userInfo.type != 2 && this.$store.state.user.company.status != 2) { //会员和供应商需要认证
      return this.$alert('请先完成资质认证', '提示', {callback:()=>this.$router.push(this.$store.state.user.userInfo.type == 1 ? '/info-qualifications' : '/center-qualifications')})
    }
  },
  methods: {
    async loadCompany(){
      if(!this.company.id){
        this.company = await getApiData(apiBkCompany.getInfo(),0,0,0,0)
        this.$store.dispatch('user/updateCompany', this.company)
      }
    },
    checkCompanyAuth(){
      return this.company.status==2
    },
    getOrder(orderBy){
      let orders = []
      orders.push('publishDate '+ (this.isOrderPublishDateOn ? 'asc' : 'desc'))
      orders.push('price ' + (this.isOrderPriceOn ? 'asc' : 'desc'))
      orders.push('discount ' + (this.isOrderDiscountOn ? 'asc' : 'desc'))
      orders.sort((a,b)=>a.indexOf(orderBy)>-1?-1:1) //按参数字段排在前面
      this.filter.order = orders.join(',')
    },
    async load(page=undefined){
      if(page) this.filter.page = page
      let map = []
      if(this.search.isbn) map.push(['isbn','like',`%${this.search.isbn}%`])
      let re = await getApiRes(apiBkBook.getList(undefined,undefined,map,'',[],this.filter), 0, 1,1)
      this.data = re.data
      this.dataCount = re.count
    },
    async del(id){
      let reConfirm = await this.$confirm('确定要删除吗?').catch((e)=>false)
      if(!reConfirm) return
      let re = await getApiRes(apiBkBook.listDel(id),0,1,1,1)
      if(re.code==0){
        this.load()
      }
    },
    async batchDel(){
      if(this.selectedRowKeys.length==0) return this.$message.error('请选择要删除的数据')
      let reConfirm = await this.$confirm('确定要删除吗?').catch((e)=>false)
      if(!reConfirm) return
      let re = await getApiRes(apiBkBook.listDel(this.selectedRowKeys),0,1,1,1)
      if(re.code==0){
        this.load()
      }
    },
    async clearLibrary(){
      let reConfirm = await this.$confirm('确定要清空吗?').catch((e)=>false)
      if(!reConfirm) return
      let re = await getApiRes(apiBkBook.clearLibrary(),0,1,1,1)
      if(re.code==0){
        this.load()
      }
    },
    async importBooks(){
      if(!this.checkCompanyAuth()) return this.$alert('请先完成资质认证', '提示', {callback:()=>this.$router.push(this.$store.state.user.userInfo.type == 1 ? '/info-qualifications' : '/center-qualifications')})
      if(this.saving) return
      if(!this.fileUrl) return this.$message.error('请选择文件')
      this.saving = true;
      let re = await getApiRes(apiBkBook.import(this.fileUrl),0,1,0,0)
      this.saving = false;
      this.fileUrl = ''
      this.visible = false
      if(re.code==0){
        if(re.msg.indexOf('导入中')>-1){
          this.$message.success('导入中，请稍后')
          this.getImportStatus(true)
        }else {
          this.load(1)
          this.$success({
            title: '成功',
            content: re.msg
          })
        }
      }else{
        this.$error({
          title: '失败',
          content: re.msg
        })
      }
    },
    async getImportStatus(showFinish = false){
      let re = await getApiRes(apiBkBook.importStatus(),0,0,0,0)
      if(re.code==0){
        this.importStatus = re.data
        if(this.importStatus.finished){
          this.load(1)
          if(showFinish) {
            this.$success({
              title: '成功',
              content: `导入完成，成功${this.importStatus.success}条，失败${this.importStatus.fail}条`
            })
          }
        }else{
          setTimeout(()=>{
            this.getImportStatus()
          },1000)
        }
      }
    },
    // 类名
    toggleActive1() {
      this.isOrderPublishDateOn = !this.isOrderPublishDateOn;
    },
    toggleActive2() {
      this.isOrderPriceOn = !this.isOrderPriceOn;
    },
    toggleActive() {
      this.isOrderDiscountOn = !this.isOrderDiscountOn;
    },
    // 类名end
    showModal() {
      if(!this.checkCompanyAuth()) return this.$alert('请先完成资质认证', '提示', {callback:()=>this.$router.push(this.$store.state.user.userInfo.type == 1 ? '/info-qualifications' : '/center-qualifications')})
      this.visible = true;
    },
    handleCancel(e) {
      this.visible = false;
    },
    // 表格
    // 搜索
    onSearch(value) {
      console.log(value);
      this.load(1)
    },
    onSubmit() {
      console.log('submit!', this.form);
    },
    // 表格
    onSelectChange(selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    },

  },
};

</script>

<style lang="scss" scoped>
.ant-input-affix-wrapper .ant-input-suffix {
  right: 0;
}
::v-deep .el-upload{
  width: 100%;height: 2.78667rem;
}
::v-deep .el-upload-list{
  position: absolute;
  top:1.1rem;
  z-index: 11;
  //width: 100%;
  padding: 0 80px;
}
</style>
